"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import Combobox_module_default from "../Combobox.module.mjs";
import { useComboboxContext } from "../Combobox.context.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Combobox/ComboboxEmpty/ComboboxEmpty.tsx
const ComboboxEmpty = factory((props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("ComboboxEmpty", null, props);
	return /* @__PURE__ */ jsx(Box, {
		...useComboboxContext().getStyles("empty", {
			className,
			classNames,
			styles,
			style
		}),
		...others
	});
});
ComboboxEmpty.classes = Combobox_module_default;
ComboboxEmpty.displayName = "@mantine/core/ComboboxEmpty";
//#endregion
export { ComboboxEmpty };

//# sourceMappingURL=ComboboxEmpty.mjs.map